const config = window.AbdelmegedTheme || {};
const storageKey = config.storageKeys?.theme || 'abdelmeged_theme';
const buttons = document.querySelectorAll('[data-theme-toggle]');
const allowedThemes = new Set(['light', 'dark']);

const setCookie = (name, value) => {
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/; max-age=31536000; samesite=lax`;
};

const preferredTheme = () => (
  window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
);

const storedTheme = () => {
  try {
    return localStorage.getItem(storageKey);
  } catch {
    return null;
  }
};

const currentTheme = () => {
  const stored = storedTheme();

  if (allowedThemes.has(stored)) {
    return stored;
  }

  const datasetTheme = document.documentElement.dataset.theme;

  return allowedThemes.has(datasetTheme) ? datasetTheme : preferredTheme();
};

const updateButtons = (theme) => {
  buttons.forEach((button) => {
    const isDark = theme === 'dark';
    const label = button.querySelector('[data-theme-toggle-label]');

    button.setAttribute('aria-pressed', String(isDark));

    if (label) {
      label.textContent = isDark ? 'Light mode' : 'Dark mode';
    }
  });
};

const applyTheme = (theme) => {
  if (!allowedThemes.has(theme)) {
    return;
  }

  document.documentElement.dataset.theme = theme;
  document.body?.classList.toggle('abdelmeged-theme-dark', theme === 'dark');
  document.body?.classList.toggle('abdelmeged-theme-light', theme === 'light');

  try {
    localStorage.setItem(storageKey, theme);
  } catch {
    // Local storage may be unavailable in private contexts.
  }

  setCookie(storageKey, theme);
  updateButtons(theme);
};

const toggleTheme = () => {
  const nextTheme = currentTheme() === 'dark' ? 'light' : 'dark';
  applyTheme(nextTheme);
  window.dispatchEvent(new CustomEvent('abdelmeged:interaction', { detail: { type: 'theme' } }));
};

if (config.features?.darkMode !== false) {
  applyTheme(currentTheme());
  buttons.forEach((button) => button.addEventListener('click', toggleTheme));
}
